import { API_URL } from '../constants';
import { apiRequest } from '../utils/api';

export interface Comment {
  id: string;
  postId: string;
  userId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    email: string;
    username: string;
    avatar?: string;
  };
}

export interface CreateCommentData {
  content: string;
}

export interface CreateCommentResponse {
  message: string;
  comment: Comment;
}

export interface CommentsResponse {
  comments: Comment[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

class CommentService {
  private baseUrl = API_URL + '/api/comments';

  async createComment(postId: string, commentData: CreateCommentData): Promise<CreateCommentResponse> {
    return apiRequest(`${this.baseUrl}/posts/${postId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commentData),
    });
  }

  async getComments(postId: string, page: number = 1, limit: number = 10): Promise<CommentsResponse> {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    return apiRequest(`${this.baseUrl}/posts/${postId}?${queryParams.toString()}`);
  }

  async updateComment(commentId: string, commentData: CreateCommentData): Promise<CreateCommentResponse> {
    return apiRequest(`${this.baseUrl}/${commentId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commentData),
    });
  }

  async deleteComment(commentId: string): Promise<void> {
    await apiRequest(`${this.baseUrl}/${commentId}`, {
      method: 'DELETE',
    });
  }
}

const commentService = new CommentService();
export default commentService;
